import { Buyer } from '@fiverr-private/header';

export default Buyer;
